import style from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

interface Props {
  percentFinished: number;
}

export const Title = ({ percentFinished }) => {
  return (
    <div
      className={`${style['textWrapper']} ${
        percentFinished > 0.6 ? style['textWrapper--animate'] : null
      }`}
    >
      <div className={style.textInnerWrapper}>
        <h1 className={style.title}>Stille i stormen</h1>
        <div className={style.byline}>Av Christian Nicolai Bjørke</div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Header/Title/index.tsx